(() => {
  const preview = document.querySelector('.ceo-product-build2');
  if (!preview) return;

  const gallery = preview.querySelector('.ceo-off-gallery--hero');
  const hydrateGallery = () => {
    if (!gallery) return;
    gallery.querySelectorAll('[data-ceo-gallery-src]').forEach((image) => {
      const src = image.dataset.ceoGallerySrc;
      const srcset = image.dataset.ceoGallerySrcset;
      if (srcset) image.srcset = srcset;
      if (src) image.src = src;
      image.removeAttribute('data-ceo-gallery-src');
      image.removeAttribute('data-ceo-gallery-srcset');
    });
  };

  if (gallery) {
    gallery.addEventListener('pointerdown', hydrateGallery, { once: true, passive: true });
    gallery.addEventListener('focusin', hydrateGallery, { once: true });
    gallery.addEventListener('keydown', hydrateGallery, { once: true });
  }

  document.documentElement.classList.add('ceo-porndemic-build2-ready');
})();
